export enum MenuMode {
  Icons = 'icons',
  Static = 'static',
  Overlay = 'overlay',
  Slim = 'slim',
  Horizontal = 'horizontal',
}
